import clsx from "clsx";
import styles from "./Fieldset.module.scss";
import { Text } from "../Text/Text";
import ErrorMessage from "../ErrorMessage/ErrorMessage";

type IFieldset = {
  legend: string;
  description?: string;
  children: React.ReactNode;
  disabled?: boolean;
  visualStyle?: "default" | "framed";
  errorMessage?: string;
};

const Fieldset = ({
  legend,
  description,
  children,
  disabled,
  errorMessage,
  visualStyle = "default",
}: IFieldset) => {
  return (
    <fieldset
      className={clsx(styles.fieldset, styles[`visualStyle-${visualStyle}`])}
      disabled={disabled}
    >
      <legend
        className={clsx(
          styles.legend,
          (description || errorMessage) && styles.withDescriptionOrErrorMessage,
        )}
      >
        {legend}
      </legend>
      {description ? (
        <div className={styles.description}>
          <Text element="p" color="faded">
            {description}
          </Text>
        </div>
      ) : null}
      {errorMessage ? (
        <div className={styles.errorMessage}>
          <ErrorMessage message={errorMessage} weight="bold" />
        </div>
      ) : null}
      {children}
    </fieldset>
  );
};

export default Fieldset;
